<template>
    <div class="">
        <input
            @keyup.enter="searchSerial"
            type="text"
            v-model="searchBySerial"
            id="searchBySerial"
            name="searchBySerial"
            class="form-control"
            placeholder="Search by Serial #"
        />
    </div>
</template>

<script>
import {computed, onMounted} from 'vue';
import {useStore} from "vuex";


export default {
    props: [],
	emits: [],
	components: {
	},
    setup(){
        const store = useStore();

        let user = computed(function () { return store.state.user });
        
        let isSpeq = computed(function () {
            return store.state.isSpeq;
        });

		onMounted(() => {

        });

		return {
            user,
            isSpeq,
		}
	},
	data() {
		return {
            // isSpeq: localStorage.getItem("isSpeq"),
            searchBySerial: ''
		}
	},
    mounted() {

    },
	methods: {
		searchSerial() {
            window.emitter.emit("changeLoaderStatus", true);
            axios.post("api/search-by-serial", {serial: this.searchBySerial})
                .then((res) => {
                    if (res.data.invoice_id != '') {
                        this.$router.push({
                            name: "invoiceInfo",
                            params: { id: res.data.invoice_id },
                        });
                    } else {
                        window.emitter.emit("alertSuccess", {
                            message: "Serial Number not found",
                            alertType: "error",
                        });
                    }
                    this.searchBySerial = '';
                    window.emitter.emit("changeLoaderStatus", false);
                });
        }
	}
}
</script>